import React, {useState} from 'react';
import editIcon from '../../../../assets/Quotes/editIcon.svg';
import editIconDark from '../../../../assets/Quotes/editIconDark.svg';
import editIconActive from '../../../../assets/Quotes/editIconActive.svg';
import { useTheme } from '../../../../context/ThemeContext';

const EditCoverageLink = props => {
   const { theme } = useTheme();
   const [isHovered, setIsHovered] = useState(false);
   const defaultEditIcon = theme === 'dark' ? editIconDark : editIcon;

   const handleMouseEnter = () => {
     setIsHovered(true);
   };
   
   const handleMouseLeave = () => {
     setIsHovered(false);
   };

   const imageSrc = theme === 'dark' ? defaultEditIcon : (isHovered ? editIconActive : defaultEditIcon);

  return (
    <div   
      onClick={props.openModal}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave} 
      className="d-flex mx-1 align-items-center fs-15 deepGray editCoverageLinkContainer pe-auto c-pointer">
       <img className="mr-1" src={imageSrc} />
       Edit Coverage
    </div>
  );
};

export default EditCoverageLink;
